import React from "react";
import ThankyouView from "./views/ThankyouPage";
import { ThankyouContextProvider } from "./ThankyouView";
import ThankyouContent from "../../../constants/contentFile.json";

const Thankyou = () => {
  return (
    <ThankyouContextProvider>
      <ThankyouView textContents={ThankyouContent.thankyouPage}/>
    </ThankyouContextProvider>
  );
};

export default Thankyou;
